import { FC } from 'react';
import { useParams } from 'react-router';
import { useQuery } from 'react-query';
import { observer } from 'mobx-react-lite';
import { useStore } from 'hooks/useRootStore';
import { useMyTranslations } from 'hooks/useMyTranslations';
import { AppLoader } from 'components/Core/AppLoader';
import ParsersForm from 'components/Forms/ParsersForm/ParsersForm';
import { editParserTranslations } from './translations';
import { EditParserTransFields } from './types';
import styles from './editParser.module.scss';

const EditParser: FC = () => {
  const {
    parsersStore: { getParserData, parserData },
  } = useStore();

  const { t } = useMyTranslations<EditParserTransFields>([editParserTranslations.name]);
  const { id } = useParams<{ id: string }>();

  const { isFetching } = useQuery('getParserData', () => (id ? getParserData(id) : Promise.resolve()), {
    retry: false,
    refetchOnWindowFocus: false,
  });

  if (isFetching) {
    return <AppLoader />;
  }

  return (
    <main className={styles.page}>
      <header className={styles.header}>
        <h2 className={styles.headerTitle}>{t('title')}</h2>
      </header>
      <div className={styles.container}>{parserData && <ParsersForm parserData={parserData} />}</div>
    </main>
  );
};

export default observer(EditParser);
